import * as React from "react";
import AutoOcrSidebar from "./AutoOcrSidebar";
import aiIcon from "../../../../images/TD AI Icon 2 Color.png";
class AutoOcrHome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    document.title = "TrinDocs - Auto OCR Config";
  }
  componentWillUnmount() {
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "container-fluid", style: { height: "100%" } }, /* @__PURE__ */ React.createElement("div", { className: "row flex-nowrap", style: { height: "100%" } }, /* @__PURE__ */ React.createElement(AutoOcrSidebar, null), /* @__PURE__ */ React.createElement("div", { className: "h-100 d-flex align-items-center" }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "p-2 col-example",
        style: {
          textAlign: "center",
          marginLeft: "100px",
          marginRight: "100px",
          width: "60%"
        }
      },
      /* @__PURE__ */ React.createElement("img", { src: aiIcon, className: "aiMenuIcon2", alt: "aiIcon" }),
      " ",
      /* @__PURE__ */ React.createElement("h2", { style: { fontWeight: "bolder", fontStyle: "italic" } }, "Auto OCR")
    ))));
  }
}
export default AutoOcrHome;
